export default "__VITE_ASSET__CMnwGwoW__"